/**
 * Smallest single replacement turning `oldText` into `newText`: trims the
 * common prefix and suffix. Used to apply whole-document rewrites as one
 * compact, undoable CodeMirror change.
 */
export function minimalEdit(oldText: string, newText: string): { from: number; to: number; text: string } {
  const max = Math.min(oldText.length, newText.length);
  let start = 0;
  while (start < max && oldText.charCodeAt(start) === newText.charCodeAt(start)) start++;
  let endOld = oldText.length;
  let endNew = newText.length;
  while (endOld > start && endNew > start && oldText.charCodeAt(endOld - 1) === newText.charCodeAt(endNew - 1)) {
    endOld--;
    endNew--;
  }
  return { from: start, to: endOld, text: newText.substring(start, endNew) };
}
